<template>
  <div>
    <h2 style="padding: 0 18px">订单提交</h2>
    <div style="padding-bottom: 100px">
      <CellGroup inset>
        <Card
          style="background-color: white"
          :desc="order.examTitle"
          :title="order.groupTitle"
          :thumb="order.groupImg"
        >
          <template #price
            ><Icon name="thumb-circle-o" size="18px" color="#20ca7b"
          /></template>
        </Card>
        <Field label="目标分数" :model-value="ExamScoreToStr" readonly />
        <Field label="目标时间" :model-value="ExamTimeToMin" readonly />
        <Field label="订单ID" readonly class="orderID">
          <template #input>
            <span class="orderIDspan">{{ order.orderID }}</span>
          </template>
          <template #button>
            <Button
              size="small"
              type="success"
              @click="copy(order.orderID.toString())"
              >复制</Button
            >
          </template>
        </Field>
      </CellGroup>
      <Divider />
      <div class="payClass" :style="{ height: !isPaid ? '260px' : '170px' }">
        <textswitch
          style="width: 200px; height: 30px"
          @switchFunction="switchChangeFun"
          switchType="text"
          defaultColor="#FFFFFF"
          :highColor="Switch.switchColor"
          :defaultValue="Switch.switchDefaultValue"
          :switchList="Switch.switchListText"
          :itemIndex="0"
          v-if="!isPaid"
        ></textswitch>
        <div>
          <div v-show="Switch.switchDefaultValue == 0">
            <div v-if="!isPaid">
              <Button @click="openZfb" block type="primary" size="small"
                >跳转支付</Button
              >
              <vue-qr
                logoSrc="portrait.jpeg"
                :text="order.alipay.qrCode"
                margin="5"
                :size="150"
              ></vue-qr>
              <CountDown
                :time="5 * 60 * 1000"
                format="请于 mm 分 ss 秒 内支付"
              />
            </div>
          </div>
          <div v-if="!isPaid">
            <div v-show="Switch.switchDefaultValue == 1">
              <WeChat title="长按图片加好友支付" />
            </div>
          </div>
        </div>
        <div v-if="isPaid">
          <img src="alipay.png" style="width: 100px; padding-top: 7px" />
          <p style="text-align: center" class="alipaySuccess">支付成功</p>
        </div>
      </div>
    </div>
    <SubmitBar
      :price="order.orderPrice * 100"
      button-text="开始考试"
      :disabled="!isPaid"
      @submit="onSubmit"
      button-color="#5D8DF3"
      tip-icon="info-o"
    >
      <template #tip v-if="!isPaid">
        你还未支付,
        <span @click="updatePaid" class="Refresh">手动刷新状态</span>
      </template>
    </SubmitBar>
  </div>
</template>

<script setup>
import {
  SubmitBar,
  CellGroup,
  Card,
  Field,
  Divider,
  Button,
  Icon,
  Toast,
  Notify,
  CountDown,
} from "vant";
import { computed } from "vue";
import vueQr from "vue-qr/src/packages/vue-qr.vue";
import { useData } from "@/composables/useData.js";
import WeChat from "@/components/WeChat.vue";
import { payService } from "@/service/payService";
import { examService } from "@/service/examService.js";
import textswitch from "@/components/switch.vue";
import { ref } from "vue";
import copy from "@/utils/copy";
import { useRouter } from "vue-router";
const router = useRouter();
const { sitedData } = useData();
let order = sitedData.value.order;
const ExamTimeToMin = computed({
  get() {
    const minute = Math.floor(order.targetExamTime / 60);
    const second = order.targetExamTime % 60;
    return `${minute}分${second}秒`;
  },
});
const ExamScoreToStr = computed({
  get() {
    return `${order.targetScores}分`;
  },
});
// 是否已支付状态
const isPaid = ref(false);

const Switch = ref({
  switchDefaultValue: 0,
  switchColor: "#3875F6",
  switchListText: [
    {
      title: "支付宝支付",
      value: 0,
    },
    {
      title: "微信支付",
      value: 1,
    },
  ],
});

// 提交考试
const onSubmit = () => {
  const toast = Toast.loading({
    message: "提交考试...",
    forbidClick: true,
    duration: 0,
  });

  examService
    .submitExam(order.orderID)
    .then((resData) => {
      toast.clear();
      if (resData.state == "success") {
        Toast.success({
          message: "提交成功",
          duration: 1000,
          onClose: () => {
            // 跳转至订单倒计时页面
            router.push("/order/" + order.orderID);
            localStorage.removeItem("orderId");
          },
        });
      } else {
        Toast.fail({
          message: resData.result,
          duration: 2000,
          onClose: () => {
            // 跳转至订单倒计时页面
            router.push("/order/" + order.orderID);
          },
        });
      }
    })
    .catch((err) => {
      toast.clear();
      Toast.fail({
        message: err == "" ? "网络通信问题，请再试一次" : err,
        duration: 2000,
      });
    });
};
// 更新支付状态
const UpdatePayStatus = () => {
  return new Promise((resolve, reject) => {
    payService
      .query(order.orderID, 0)
      .then((res) => {
        if (!res.success) {
          reject(res.message);
        }
        if (res.result == 1) {
          // 支付成功
          resolve(true);
        }
        resolve(false);
      })
      .catch((errorRes) => {
        reject(errorRes);
      });
  });
};
// 手动点击更新支付状态
const updatePaid = () => {
  const toast = Toast.loading({
    duration: 0,
    forbidClick: true,
    message: "更新支付状态",
  });

  // 手动查询状态
  UpdatePayStatus()
    .then((payStatus) => {
      toast.clear();
      // 未支付
      if (!payStatus) {
        Toast.fail("你还未支付噢~");
        return;
      }
      // 支付成功
      isPaid.value = true;
    })
    .catch((error) => {
      toast.clear();
      // 异常
      Notify({
        type: "danger",
        message: error == "" ? "网络通信问题，请再试一次" : error,
      });
    });
};
const switchChangeFun = (e) => {
  if (e.swithcSelectItem.value == 0) {
    // 点击支付宝支付标签
    Switch.value.switchColor = "#3875F6";
  } else {
    // 点击微信支付标签
    Switch.value.switchColor = "#57BD6A";
  }
  Switch.value.switchDefaultValue = e.swithcSelectItem.value;
};
const openZfb = () => {
  window.open(
    "https://ulink.alipay.com/?scheme=alipays%3A%2F%2Fplatformapi%2Fstartapp%3FsaId%3D10000007%26clientVersion%3D3.7.0.0718%26qrcode%3D" +
      encodeURIComponent(order.alipay.qrCode)
  );
};
// 轮训查询状态
function Training() {
  let timer = null;
  UpdatePayStatus()
    .then((payStatus) => {
      if (!payStatus) {
        timer = setTimeout(() => {
          Training();
        }, 2000);
      } else {
        // 支付成功
        clearTimeout(timer);
        isPaid.value = true;
      }
    })
    .catch((error) => {
      clearTimeout(timer);
      // 异常
      Notify({
        type: "danger",
        message: error == "" ? "网络通信问题，请再试一次" : error,
      });
    });
}

// 查询订单信息
const queryOrder = () => {
  payService
    .query(order.orderID, 1)
    .then((res) => {
      if (res.state != "success") {
        throw res.result;
      }
      // console.log(res);
      order.examTitle = res.result.examTitle;
      order.groupTitle = res.result.groupTitle;
      order.groupImg = res.result.groupImg;
      order.targetScores = res.result.targetScore;
      order.targetExamTime = res.result.targetExamTime;
      order.alipay.qrCode = res.result.payQr;
      order.orderPrice = res.result.money;
      // 开始轮询
      Training();
    })
    .catch((errorRes) => {
      // console.log(errorRes);
      Toast.fail({
        message: errorRes == "" ? "网络通信问题，请再试一次" : errorRes,
        duration: 3000,
        forbidClick: true,
        onClose: () => location.reload(),
      });
      // 清空会话
      localStorage.removeItem("orderId");
    });
};

// 查询订单
queryOrder();
</script>

<!-- 局部有效css -->
<style scoped>
.Refresh {
  color: #1a74c2;
  text-decoration: underline;
}
.orderID {
  align-items: center;
}
.orderIDspan {
  color: #2d99cf;
  font-size: 18px;
  font-weight: 800;
  text-decoration: underline;
}

.payClass {
  width: 40%;
  display: flex;
  margin: 0px auto;
  flex-direction: column;
  align-items: center;
  height: 260px;
}
.alipaySuccess {
  text-align: center;
  font-size: 26px;
  margin: 0;
  font-weight: bold;
  color: #46accf;
}
</style>
